var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"white","position":"absolute","height":"100%","width":"100%"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"margin-top":"15%"},attrs:{"src":require("../../../public/icee_admin/images/404.jpg")}})])])
}]

export { render, staticRenderFns }